export const LANGS = ['it', 'en', 'de', 'fr'];
export const SITE_URL = 'https://studioaccordinicarillo.it';

const PAGES = {
  servizi: { it: 'servizi', en: 'services', de: 'leistungen', fr: 'services' },
  'chi-siamo': { it: 'chi-siamo', en: 'about-us', de: 'ueber-uns', fr: 'a-propos' },
  contatti: { it: 'contatti', en: 'contact', de: 'kontakt', fr: 'contact' },
  faq: { it: 'faq', en: 'faq', de: 'faq', fr: 'faq' },
  'privacy-policy': { it: 'privacy-policy', en: 'privacy-policy', de: 'datenschutz', fr: 'politique-de-confidentialite' },
  'cookie-policy': { it: 'cookie-policy', en: 'cookie-policy', de: 'cookie-richtlinie', fr: 'politique-cookies' },
};

export const SERVICE_SLUGS = {
  immobiliare: { en: 'real-estate', de: 'immobilien', fr: 'immobilier' },
  successioni: { en: 'successions', de: 'erbschaften', fr: 'successions' },
  aziende: { en: 'companies', de: 'unternehmen', fr: 'entreprises' },
  patrimoniali: { en: 'asset-protection', de: 'vermoegensschutz', fr: 'protection-patrimoniale' },
  procure: { en: 'powers-of-attorney', de: 'vollmachten', fr: 'procurations' },
  consulenza: { en: 'legal-advice', de: 'rechtsberatung', fr: 'conseil-juridique' },
  agricola: { en: 'agriculture', de: 'landwirtschaft', fr: 'agriculture' },
  ipocatastali: { en: 'land-registry-searches', de: 'grundbuchauszuege', fr: 'recherches-hypothecaires' },
  vidimazione: { en: 'book-certification', de: 'buecherbeglaubigung', fr: 'visa-des-registres' },
};

const serviceSlug = (it, lang) => (lang === 'it' ? it : SERVICE_SLUGS[it]?.[lang] || it);

// Italian path ("/servizi/immobiliare") -> localized path ("/en/services/real-estate"); other paths unchanged.
export const localize = (itPath, lang) => {
  const [, first = '', second] = itPath.split('/');
  if (first === '') return `/${lang}`;
  if (!PAGES[first]) return itPath;
  const base = `/${lang}/${PAGES[first][lang]}`;
  return second && first === 'servizi' ? `${base}/${serviceSlug(second, lang)}` : base;
};

// Localized path -> { lang, itPath } or null when the path has no language prefix.
export const parseLocalized = (pathname) => {
  const [, lang, page, sub] = pathname.split('/');
  if (!LANGS.includes(lang)) return null;
  if (!page) return { lang, itPath: '/' };
  const itPage = Object.keys(PAGES).find((k) => PAGES[k][lang] === page);
  if (!itPage) return { lang, itPath: '/not-found' };
  if (sub && itPage === 'servizi') {
    const itSlug = lang === 'it' ? sub : Object.keys(SERVICE_SLUGS).find((k) => SERVICE_SLUGS[k][lang] === sub);
    return { lang, itPath: `/servizi/${itSlug || sub}` };
  }
  return { lang, itPath: `/${itPage}` };
};

export const isLocalizable = (itPath) => itPath === '/' || Boolean(PAGES[itPath.split('/')[1]]);
